import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Col, Form, Input, Row, Spin, Table } from "antd";
import React, { useRef, useState } from "react";
import FormLabel from "../../../../components/label/FormLabel";
import { showError, showSuccess } from "../../../../helpers/alerts";
import {
  ec2InstanceCreation,
  getProjectInfoById,
  infraCreation,
} from "./../../../../api/apiCallManager";
import useGithubConnectionFormData from "../../../../components/hooks/useGithubConnectionFormData";
import useProjectInfoQuery from "../../../../components/hooks/useProjectInfoQuery";
import { useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { namingPolicy } from "../../../../helpers/formValidatorRules";
import { useEc2ZustandStore } from "../../../../zustand/store/useEc2ZustandStore";

const InstanceTable = (props) => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // State to store selected row data
  const formValuesRef = useRef(null);
  const { ec2ZustandEditData, setEc2ZustandEditData } = useEc2ZustandStore(); // Access the Zustand setter

  const { id } = useParams();
  const {
    data: projectInfoData,
    error,
    isLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);
  const queryClient = useQueryClient();
  const { formData, isFormDataLoaded } = useGithubConnectionFormData();
  const infraCreationMutation = useMutation({
    mutationFn: infraCreation,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        setIsSubmit(true);
        showSuccess("Infrastructure created successfully!");
        setSelectedRow(null);
        queryClient.invalidateQueries({ queryKey: ["_keyinfraFormList"] });
        queryClient.invalidateQueries({
          queryKey: ["assignedClientInfraConfig_"],
        });
        if (props.instanceCategory) {
        } else {
          props.setChecked(true);
        }
      } else {
        setIsSubmit(false);
      }
    },
    onError: () => {
      setIsSubmit(false);
    },
  });

  const ec2InstanceCreationMutation = useMutation({
    mutationFn: ec2InstanceCreation,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        showSuccess("Infrastructure Provision successfully!");
        infraCreationMutation.mutate({
          ...formValuesRef.current,
          isEc2Edit: ec2ZustandEditData?.record_id,
        });
      } else {
        setIsSubmit(false);
      }
    },
    onError: (err) => {
      showError(err);
      setIsSubmit(false);
    },
  });

  const columns = [
    {
      title: "Instance Type",
      dataIndex: "InstanceType",
      key: "InstanceType",
      width: 20,
    },
    {
      title: "GPU",
      dataIndex: "GPU",
      key: "GPU",
      width: 20,
    },
    {
      title: "CPU",
      dataIndex: "CPU",
      key: "CPU",
      width: 20,
    },
    {
      title: "Memory (GB)",
      dataIndex: "Memory(MiB)",
      key: "Memory",
      width: 20,
      // render: (item) => item / 1024 + "GB",
    },
    {
      title: "Cost Per Hour ($)",
      dataIndex: "CostPerHour(USD)",
      key: "CostPerHour",
      render: (item) => parseFloat(item),
      width: 30,
    },
  ];
  const handleSave = (values) => {
    let infraTypeLocal = "";
    if (ec2ZustandEditData?.infraType) {
      infraTypeLocal = ec2ZustandEditData?.infraType;
    } else {
      infraTypeLocal = props.instanceCategory ? "server" : "client";
    }

    if (selectedRow) {
      const payload = {
        cpu: selectedRow.CPU,
        memory: selectedRow["Memory(MiB)"],
        costPerHour: selectedRow["CostPerHour(USD)"],
        region: ec2ZustandEditData?.region || selectedRow.Region,
        instanceType: selectedRow.InstanceType,
        vpcId: selectedRow.VPCId,
        subnetId: selectedRow.SubnetId,
        availabilityZone: selectedRow.AvailabilityZone,
        name: values.name,
        reponame: formData[0]?.repoUrl,
        accesstoken: formData[0]?.accessToken,
        project_key: projectInfoData.project_key,
        branch: formData[0]?.branchName,
        infraType: infraTypeLocal,
        clientName:
          ec2ZustandEditData?.clientName ||
          props?.selectedInfraClient?.clientName ||
          "",
      };
      setIsSubmit(true);
      // console.log(payload);
      ec2InstanceCreationMutation.mutate(payload);
      formValuesRef.current = payload;
    } else {
      showError("Please select the row!");
    }
  };

  return (
    <div>
      {/* {formData
        ? JSON.stringify({
            reponame: formData[0]?.repoUrl,
            accesstoken: formData[0]?.accessToken,
            branch: formData[0]?.branchName,
          })
        : ""} */}
      {/* projectname s3name branch */}
      {/* {JSON.stringify(ec2ZustandEditData?.infraType)} */}
      {selectedRow && (
        <Form
          requiredMark={false}
          initialValues={{ name: ec2ZustandEditData?.name }}
          onFinish={handleSave}
        >
          <Row gutter={16}>
            <Col span={6}></Col>
            <Col span={15}>
              <Form.Item
                name="name"
                label={
                  <FormLabel>
                    <span className="text-[13px]">Instance Name</span>
                  </FormLabel>
                }
                rules={[{ validator: namingPolicy }]}
                // rules={[{ required: true, message: "Enter Instance Name!" }]}
              >
                <Input disabled={ec2ZustandEditData?.name} />
              </Form.Item>
            </Col>
            <Col span={3}>
              <button
                type="submit"
                disabled={isSubmit}
                className="hover:bg-gray-100    bg-white text-[11px] h-8 w-[100%]  rounded-[5px] border border-[#d9d9d9]"
              >
                <Spin
                  spinning={isSubmit}
                  className="mx-2"
                  indicator={<LoadingOutlined spin />}
                  size="small"
                />
                {isSubmit ? "" : "Save"}
              </button>
            </Col>
          </Row>
        </Form>
      )}
      <Table
        rowSelection={{
          type: "radio",
          selectedRow,
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRow(selectedRows[0]); // Store the selected row data
          },
        }}
        loading={props.loading}
        columns={columns}
        bordered
        className="user-table-theme"
        dataSource={props.data}
      />
    </div>
  );
};

export default InstanceTable;
